"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SafeCast__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [{
    internalType: "uint8",
    name: "bits",
    type: "uint8"
  }, {
    internalType: "int256",
    name: "value",
    type: "int256"
  }],
  name: "SafeCastOverflowedIntDowncast",
  type: "error"
}, {
  inputs: [{
    internalType: "int256",
    name: "value",
    type: "int256"
  }],
  name: "SafeCastOverflowedIntToUint",
  type: "error"
}, {
  inputs: [{
    internalType: "uint8",
    name: "bits",
    type: "uint8"
  }, {
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "SafeCastOverflowedUintDowncast",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "value",
    type: "uint256"
  }],
  name: "SafeCastOverflowedUintToInt",
  type: "error"
}];
const _bytecode = "0x60566050600b82828239805160001a6073146043577f4e487b7100000000000000000000000000000000000000000000000000000000600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220766ba30f63d8006c724a4c3d3663c3583e9781fe2b0febfa17c7932f5b6cace464736f6c63430008160033";
const isSuperArgs = xs => xs.length > 1;
class SafeCast__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.SafeCast__factory = SafeCast__factory;
_defineProperty(SafeCast__factory, "bytecode", _bytecode);
_defineProperty(SafeCast__factory, "abi", _abi);